import { inflate } from "pako";

// Decode a base64 string into a Uint8Array (browser & Node fallback)
export function decodeBase64ToUint8(b64: string): Uint8Array {
  try {
    if (typeof atob === "function") {
      const binary = atob(b64);
      const len = binary.length;
      const bytes = new Uint8Array(len);
      for (let i = 0; i < len; i++) bytes[i] = binary.charCodeAt(i);
      return bytes;
    }

    const buf = (globalThis as any).Buffer?.from(b64, "base64");
    if (buf) return new Uint8Array(buf);
  } catch {
    /* ignore */
  }
  return new Uint8Array();
}

// Attempt to decompress a base64 zlib-compressed string. Returns null if not valid.
export function tryDecompressBase64Zlib(b64: string): string | null {
  // Base64 fast heuristic
  if (!/^[A-Za-z0-9+/=]+$/.test(b64) || b64.length < 16) return null;
  try {
    const inflated = inflate(decodeBase64ToUint8(b64), { to: "string" });
    return typeof inflated === "string" ? inflated : null;
  } catch {
    return null;
  }
}
